import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Filters = Partial<{
  companyId: string[];
  carrierId: string[];
  supplierId: string[];
  indicatorStatus: string[];
  invoiceNumber: string;
  emissionDateFrom: string;
  emissionDateTo: string;
  deadlineDate: string;
  sameCarrierCnpj: boolean;
  originUf: string;
  originIbge: string;
  destinationUf: string;
  destinationIbge: string;
}>;

export type PaginationControl = {
  page: number;
  limit: number;
  orderBy?: string;
  orderByDirection?: 'asc' | 'desc';
};

type State = {
  filters: Filters;
  paginationControl: PaginationControl;
};

type Actions = {
  updateFilters: (filters: Filters) => void;
  updatePartialFilters: (filters: Filters) => void;
  updatePaginationControl: (paginationControl: Partial<PaginationControl>) => void;
  clearState: () => void;
};

type Options = {
  persisted?: boolean;
}

const getInitialState = (): State => ({
  filters: {},
  paginationControl: {
    page: 1,
    limit: 10,
  },
});

const PERSISTENCE_OPTIONS = {
  name: 'invoices-for-trip-creation-search-params',
  version: 1,
};

const store = create<State & Actions>(
  (set) => ({
    ...getInitialState(),
    updateFilters: (filters) => set({ filters }),
    updatePartialFilters: (filters) => {
      return set((state) => ({
        filters: {
          ...state.filters,
          ...filters,
        }
      }))
    },
    updatePaginationControl: (paginationControl) => {
      return set((state) => ({
        paginationControl: {
          ...state.paginationControl,
          ...paginationControl,
        },
      }));
    },
    clearState: () => set(getInitialState()),
  }),
);

const persistStore = create(
  persist<State & Actions>(
    (set) => ({
      ...getInitialState(),
      updateFilters: (filters) => set({ filters }),
      updatePartialFilters: (filters) => {
        return set((state) => ({
          filters: {
            ...state.filters,
            ...filters,
          }
        }))
      },
      updatePaginationControl: (paginationControl) => {
        return set((state) => ({
          paginationControl: {
            ...state.paginationControl,
            ...paginationControl,
          },
        }));
      },
      clearState: () => set(getInitialState()),
    }),
    PERSISTENCE_OPTIONS,
  ),
);

export const useInvoicesForTripCreationSearchParams = (options?: Options) => {
  return options?.persisted ? persistStore() : store();
};